module.exports = __webpack_public_path__ + "img/ford-plaza-gal-4.4e9eb221.jpg";